import { FC, PropsWithChildren } from "react";
const Fact: FC<
  PropsWithChildren<{ label: string; itemClassName?: string }>
> = ({ children, label, itemClassName = "" }) => {
  return (
    <div
      className={`${itemClassName} lg:text-2xl text-sm flex flex-col justify-center items-start`}
    >
      <p className=" text-blue-dark">{label}</p>
      <p className="font-bold text-center ">{children}</p>
    </div>
  );
};

const Keyfacts: FC<PropsWithChildren<{ label: string }>> = ({
  label,
  children,
}) => {
  return (
    <div className="w-full container lg:my-16 my-10">
      <h2 className="text-blue-dark lg:text-5xl text-4xl font-bold  lg:my-9 my-7">
        {label}
      </h2>
      <div className="grid lg:grid-cols-5 grid-cols-2 w-full gap-y-9 ">
        {children}
      </div>
    </div>
  );
};
export default Object.assign(Keyfacts, {
  Fact,
});
